import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsPieChart from './AnalyticsPieChart';

function AnalyticsChartSegment({ title, total, count, label, data }) {
  return (
    <div className="analytics-content__segment">
      <p className="analytics-header-text">{title}</p>
      <p>
        <span className="analytics-count-total">{total}</span>
        <span className="analytics-count-finished">
          {' '}
          / {count} {label}
        </span>
      </p>
      <AnalyticsPieChart data={data} label={label} count={count} />
    </div>
  );
}

AnalyticsChartSegment.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AnalyticsChartSegment;
